import { ArrowDropDown, Cloud } from '@mui/icons-material';
import {
  CircularProgress,
  IconButton,
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  PopoverOrigin,
} from '@mui/material';
import { useButtonMenu } from '@procureai/ui-mui';
import { ReactNode } from 'react';

import { ModulePageHeader, ModulePageHeaderProps } from '~/components/ModulePageHeader/ModulePageHeader';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export interface BaseDetailHeaderProps extends Pick<ModulePageHeaderProps, 'title' | 'center' | 'tabs'> {
  loading?: boolean;
  actionsRight?: ReactNode;
  links?: {
    title: string;
    url: string;
  }[];
  icon?: ReactNode | null;
}

export const BaseDetailHeader = ({
  title,
  links,
  center,
  loading,
  tabs,
  actionsRight,
  icon,
}: BaseDetailHeaderProps) => {
  const { menuProps, buttonProps } = useButtonMenu();

  return (
    <>
      <ModulePageHeader
        tabs={tabs}
        icon={icon}
        title={title}
        left={
          loading ? (
            <CircularProgress size={20} />
          ) : links && links.length ? (
            <IconButton size="small" aria-label="more" aria-controls="long-menu" aria-haspopup="true" {...buttonProps}>
              <ArrowDropDown />
            </IconButton>
          ) : null
        }
        center={center}
        right={actionsRight}
      />
      <Menu {...menuProps} anchorOrigin={ANCHOR_ORIGIN} transformOrigin={TRANSFORM_ORIGIN}>
        {links &&
          links.map((link, i) => (
            <MenuItem key={i} component={Link} color="inherit" target="_blank" href={link.url} rel="noreferrer">
              <ListItemIcon>
                <Cloud fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={link.title} />
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};
